function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import 'researcher/digital-orders/styles/digital-orders.scss';
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import PreferredGroupWelcome from 'researcher/components/PreferredGroupWelcome';
import Redirect from 'shared/components/Redirect';
import DigitalEditingHeader from './DigitalEditingHeader';
import DigitalEditingInstructions from './DigitalEditingInstructions';
import DigitalEditingMarketingVideo from './DigitalEditingMarketingVideo';
import DigitalEditingOverview from './DigitalEditingOverview';
import DigitalEditingSidebar from './DigitalEditingSidebar';
import DigitalEditingPurchaseFeatures from './DigitalEditingPurchaseFeatures';
import ManageDigitalEdits from './ManageDigitalEditsContainer';
var DigitalEdits = function DigitalEdits(_ref) {
  var accessType = _ref.accessType,
    allowsDigitalEditing = _ref.allowsDigitalEditing,
    digitalEditEnabled = _ref.digitalEditEnabled,
    displayDigitalEditingVideo = _ref.displayDigitalEditingVideo,
    availableDigitalEditingPurchase = _ref.availableDigitalEditingPurchase,
    currency = _ref.currency,
    digitalEditingPurchase = _ref.digitalEditingPurchase,
    digitalEditingSurveyUrl = _ref.digitalEditingSurveyUrl,
    displayDigitalEditingResults = _ref.displayDigitalEditingResults,
    location = _ref.location,
    page = _ref.page,
    searchDigitalEdits = _ref.searchDigitalEdits,
    status = _ref.status,
    uuid = _ref.uuid,
    digitalEditingVideoUrl = _ref.digitalEditingVideoUrl,
    isCurieLaunched = _ref.isCurieLaunched;
  if (isCurieLaunched) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/rubriq",
      replace: true
    });
  }
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    digitalEditingTrialEnabled = _useState2[0],
    setDigitalEditingTrialEnabled = _useState2[1];
  useEffect(function () {
    if (allowsDigitalEditing) {
      searchDigitalEdits({
        page: page
      });
    }
  }, []);
  useEffect(function () {
    if (displayDigitalEditingResults && digitalEditingTrialEnabled) {
      setDigitalEditingTrialEnabled(false);
    }
  }, [displayDigitalEditingResults]);
  if (!allowsDigitalEditing) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/researcher"
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PreferredGroupWelcome, null), /*#__PURE__*/React.createElement("div", {
    className: "container digital-edits"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row my-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(DigitalEditingHeader, {
    accessType: accessType,
    busy: status.searchBusy
  }), digitalEditEnabled ? /*#__PURE__*/React.createElement(DigitalEditingInstructions, {
    accessType: accessType,
    digitalEditingPurchase: digitalEditingPurchase
  }) : null)), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-8 col-12"
  }, /*#__PURE__*/React.createElement(IdentifyPage, {
    bodyClassName: "bg-gray-lighter",
    title: "Automated English language editing"
  }), displayDigitalEditingResults || digitalEditingTrialEnabled ? /*#__PURE__*/React.createElement(ManageDigitalEdits, {
    location: location,
    digitalEditingTrialEnabled: digitalEditingTrialEnabled
  }) : /*#__PURE__*/React.createElement(DigitalEditingOverview, null), displayDigitalEditingVideo ? /*#__PURE__*/React.createElement("div", {
    className: "mt-3 digital-editing-video"
  }, /*#__PURE__*/React.createElement(DigitalEditingMarketingVideo, {
    url: digitalEditingVideoUrl
  })) : null), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4 col-12 position-relative"
  }, displayDigitalEditingResults || digitalEditingTrialEnabled ? /*#__PURE__*/React.createElement(DigitalEditingSidebar, {
    accessType: accessType,
    digitalEditEnabled: digitalEditEnabled,
    digitalEditingPurchase: digitalEditingPurchase,
    digitalEditingSurveyUrl: digitalEditingSurveyUrl,
    uuid: uuid
  }) : null, !digitalEditEnabled ? /*#__PURE__*/React.createElement(DigitalEditingPurchaseFeatures, {
    availableDigitalEditingPurchase: availableDigitalEditingPurchase,
    currency: currency
  }) : null))));
};
export default DigitalEdits;